import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Placeholder de la ruta '/app' (sin módulo todavía).
 *
 * '/app' no tenía hijo que hiciera match: la navegación fallaba con "Cannot match any routes"
 * y el usuario quedaba atrapado en /login con el loader "Cargando información del usuario...".
 * Este componente no pinta nada; solo mantiene la ruta válida mientras FullComponent resuelve
 * los menús del rol y redirige al primer menú del portal.
 */
@Component({
  selector: 'app-app-landing',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppLandingComponent {}
